type ModuleType = typeof import('@tencent/aegis-node-sdk');

let asyncPromise: Promise<ModuleType> | null = null;

const getNodeAegis: () => Promise<ModuleType> = () => {
  if (asyncPromise) {
    return asyncPromise;
  }
  asyncPromise = import('@tencent/aegis-node-sdk');
  return asyncPromise;
};

export default getNodeAegis;
